export const SET_BASE_EVENT_LANGUAGE = 'SET_BASE_EVENT_LANGUAGE';


export const setBaseEventLanguage = (language) => {
    return {
        type: SET_BASE_EVENT_LANGUAGE,
        payload: language
    }
}